import { TextAreaBoxSolutions } from './TextAreaBoxSolutions';

export default TextAreaBoxSolutions;
